import {FETCH_DUELOS_ABERTOS,
        FETCH_DUELOS_FINALIZADA,
        FETCH_DISCIPLINAS,
        FETCH_ID_DUELO,
        ADD_NOVO_DUELO,
       // STATUS_DUELO_ABERTO,
        } from '../actions/batalhaAction';

const INITIAL_STATE = { 
                        allDueloAberto     : [],
                        allDueloFinalizada : [],
                        allDisciplina      : [],
                        allQuestaoAprovar  : [],
                        allQuestaoJogo     : [],
                        allComentPost      : [],
                        qtdComent          : "",
                        idDuelo            : "",
                      
                        post               : null
                      };

export default function(state = INITIAL_STATE,action){

    switch (action.type) {

        case FETCH_DUELOS_ABERTOS:
             return { ...state, allDueloAberto : (action.payload.data?action.payload.data:[]) }

        case FETCH_DUELOS_FINALIZADA:
             return { ...state, allDueloFinalizada : (action.payload.data?action.payload.data:[]) }

        case FETCH_DISCIPLINAS:
             return { ...state, allDisciplina : (action.payload.data?action.payload.data:[]) }
             
        case FETCH_ID_DUELO:
             return { ...state, idDuelo : action.payload }

        case ADD_NOVO_DUELO:

           const duelo =  {
                                "desafiante": {

                                    "use_id"    : action.payload.data.desafiante.use_id,
                                    "use_nome"  : action.payload.data.desafiante.use_nome,
                                    "use_email" : action.payload.data.desafiante.use_email,
                                    "use_login" : action.payload.data.desafiante.use_login,
                                    "use_foto"  : action.payload.data.desafiante.use_foto,
                                    "use_cpf"   : action.payload.data.desafiante.use_cpf
                                },
                                "desafiado": {

                                    "use_id"    : action.payload.data.desafiado.use_id,
                                    "use_nome"  : action.payload.data.desafiado.use_nome,
                                    "use_email" : action.payload.data.desafiado.use_email,
                                    "use_login" : action.payload.data.desafiado.use_login,
                                    "use_foto"  : action.payload.data.desafiado.use_foto,
                                    "use_cpf"   : action.payload.data.desafiado.use_cpf
                                },
                                "dados"                         : {
                                "due_cod_desafiante"            : action.payload.data.dados.due_cod_desafiante,
                                "due_cod_desafiado"             : action.payload.data.dados.due_cod_desafiado,
                                "isDesafiante"                  : 1,
                                "due_flag_recusado"             : null,
                                "due_ultima_questao_desafiado"  : null,
                                "due_ultima_questao_desafiante" : null,
                                "due_semestre"                  : action.payload.data.dados.due_semestre,
                                "due_cod_curso"                 : action.payload.data.dados.due_cod_curso,
                                "updated_at"                    : action.payload.data.dados.updated_at,
                                "created_at"                    : action.payload.data.dados.created_at,
                                "due_id"                        : action.payload.data.dados.due_id
                                }
                            } 
                         

           return { ...state, allDueloAberto: [duelo,...state.allDueloAberto] } 


       
      
       // case STATUS_DUELO_ABERTO:

           // state.allDueloAberto.filter(item => (item.dados.due_id === action.payload.id ? item.dados.due_flag_recusado = action.payload.acao : item.dados.due_flag_recusado));


        default:
           return state;
      
    }

}





// WEBPACK FOOTER //
// ./src/reducers/reducer_batalha.js